import { render } from "./SidebarSubmenuItem.vue?vue&type=template&id=6ec120c8"
import script from "./SidebarSubmenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarSubmenuItem.vue?vue&type=script&lang=js"

import "../styles/SidebarSubmenuItem.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__